import React from 'react';
import SlotCard from './SlotCard';
import './EtapeSlot.css';

export default function EtapeSlot({ evenement, slotSelectionne, onSelectionner, erreur }) {
  const slots = evenement?.slots || [];

  if (slots.length === 0) {
    return (
      <div className="etape-slot">
        <div className="slot-vide muted">Aucune fenêtre horaire configurée pour cet événement.</div>
      </div>
    );
  }

  return (
    <div className="etape-slot">
      <div className="etape-intro">
        <p className="muted">Choisissez votre créneau de ramassage.</p>
      </div>

      <div className="slots-grille">
        {slots.map(slot => (
          <SlotCard
            key={slot.heure || slot.heure_debut}
            slot={slot}
            selected={slotSelectionne === (slot.heure || slot.heure_debut)}
            onSelect={onSelectionner}
          />
        ))}
      </div>

      {erreur && <div className="etape-erreur">{erreur}</div>}
    </div>
  );
}
